export { default as Bandage } from './Bandage'
export { default as Bones } from './Bones'
export { default as Brain } from './Brain'
export { default as Drugs } from './Drugs'
export { default as HandWithHeart } from './HandWithHeart'
export { default as Heartbeat } from './Heartbeat'
export { default as HeartCheckmark } from './HeartCheckmark'
export { default as MedicalBook } from './MedicalBook'
export { default as MedicalCase } from './MedicalCase'
export { default as Siren } from './Siren'
export { default as Stethoscope } from './Stethoscope'
export { default as Stomach } from './Stomach'
export { default as Syringe } from './Syringe'
export { default as Teeth } from './Teeth'
export { default as Toothbrush } from './Toothbrush'
